const select = {
  select:'Вибрати',
  placeholder:'Виберіть елемент',
  sort_by: 'Сортувати за',
  favorite: 'Улюблене',
  title: 'Назва',
  developer: 'Розробник',
  mostPromoted: 'Найбільш просуваний',
  ipAddress: 'IP-адреса',
  appPackage: 'Пакет програми',
  selectAppId: 'Ідентифікатор програми',
  developerName: "Ім'я розробника",
  paypalEmail: 'Електронна адреса Paypal',
  paypalEmailFraud: 'Електронна адреса Paypal (шахрайство)',
  emailService: 'Служба електронної пошти',
  developerEmail: 'Електронна адреса розробника',
  cpiAppPackage: 'Пакет програми Cpi',
  userEmail: 'Електронна адреса користувача',
  keyword: 'Ключове слово',
};
export default select;
